<template>
    <div>
        <p>
            <b-checkbox v-model="keep">Garder les lignes qui correspondent aux conditions (au lieu de les supprimer)</b-checkbox>
        </p>
    </div>
</template>

<script>
    import uniqueId from "lodash.uniqueid";

    export default {
        name: "supprimer_lignes_step",
        props: {
            data: { default: () => [] },
            files: { default: () => [] },
            client: { default: null },
            size: { default: 1000 },
            step_position: { default: 0 }
        },
        data() {
            return {
                id: uniqueId(""),
                keep: false
            };
        },
        methods: {
            save() {
                return {
                    keep: this.keep
                };
            },
            async load(data) {
                if (!data) data = {};
                this.keep = !!data.keep;
            }
        }
    };
</script>

<style scoped>
</style>
